function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_67702",
  d: "M17.754,30.268A12.935,12.935,0,0,0,30.618,17.417a12.857,12.857,0,0,0-25.714,0A12.932,12.932,0,0,0,17.754,30.268ZM11.739,17.43a1.194,1.194,0,0,1,1.243-1.243h3.542V12.645a1.168,1.168,0,0,1,1.205-1.23,1.184,1.184,0,0,1,1.243,1.23v3.542h3.555a1.23,1.23,0,1,1,0,2.461H18.972V22.19a1.191,1.191,0,0,1-1.243,1.23,1.175,1.175,0,0,1-1.205-1.23V18.648H12.982A1.188,1.188,0,0,1,11.739,17.43Z",
  transform: "translate(-4.903 -4.566)",
  fill: "currentColor"
});

function SvgPlusSignFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.714 25.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSignFilled);
export default __webpack_public_path__ + "static/media/plus-sign-filled.1c71924a.svg";
export { ForwardRef as ReactComponent };